<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <iframe id="mainIframe"
            ref="mainIframe"
            name="mainIframe"
            style="width: 100%;height: 100%;margin: auto"
            src="http://112.64.165.250:7070/index.html#/FoodWeekMenuView?template=self"
            frameborder="0"
            scrolling="no">
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'weekMenu',
  data () {
    return {}
  },
  created () {
  },
  mounted () {
    // let routeUrl = this.$router.resolve({
    //   path: this.openUrl.index
    // })
    window.open('http://112.64.165.250:7070/index.html#/FoodWeekMenuView?template=self', '_blank')
    setTimeout(() => {
      history.back()
    }, 500)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/weekMenu.vue